import { useEffect, useState } from 'react';

/** Quem está comemorando agora (marco de milhões): o placar e o peão trocam para a arte feliz. */
export function useCelebrating(): Set<string> {
  const [who, setWho] = useState<Record<string, number>>({});
  useEffect(() => {
    const on = (e: Event) => {
      const { player, until } = (e as CustomEvent<{ player: string; until: number }>).detail;
      setWho((w) => ({ ...w, [player]: until }));
      setTimeout(() => setWho((w) => ({ ...w })), until - Date.now() + 50);
    };
    window.addEventListener('tt:celebrate', on);
    return () => window.removeEventListener('tt:celebrate', on);
  }, []);
  const now = Date.now();
  return new Set(Object.entries(who).filter(([, t]) => t > now).map(([p]) => p));
}
